import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./Navbar.css";
import logo from "../assets/logo.png";
import { setAuthToken } from "../api";
import api from "../api";

const LEADER_ROLES = ["admin", "events_manager", "welfare_manager"];

const Navbar = () => {
  const [isOpen,     setIsOpen]     = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLeader,   setIsLeader]   = useState(false);
  const [scrolled,   setScrolled]   = useState(false);
  const navigate  = useNavigate();
  const location  = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    setScrolled(window.scrollY > 20);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Re-check login + role on every route change
  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    setIsLoggedIn(!!token);

    if (token) {
      api.get("members/dashboard/")
        .then((r) => {
          const role = r.data?.role;
          setIsLeader(LEADER_ROLES.includes(role));
        })
        .catch(() => setIsLeader(false));
    } else {
      setIsLeader(false);
    }
  }, [location]);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu  = () => setIsOpen(false);

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("isAuthenticated");
    setAuthToken(null);
    setIsLoggedIn(false);
    setIsLeader(false);
    closeMenu();
    navigate("/");
  };

  return (
    <header className={`navbar ${scrolled ? "scrolled" : ""}`}>
      <div className="navbar-logo">
        <Link to="/" onClick={closeMenu}>
          <img src={logo} alt="Marakwet Community Logo" />
        </Link>
      </div>

      <div className={`hamburger ${isOpen ? "active" : ""}`} onClick={toggleMenu}>
        <span></span>
        <span></span>
        <span></span>
      </div>

      <nav className={`navbar-links ${isOpen ? "open" : ""}`}>
        <ul>
          <li><Link to="/"              onClick={closeMenu}>Home</Link></li>
          <li><Link to="/about"         onClick={closeMenu}>About Us</Link></li>
          <li><Link to="/events"        onClick={closeMenu}>Events</Link></li>
          <li><Link to="/membership"    onClick={closeMenu}>Membership</Link></li>
          <li><Link to="/blog"          onClick={closeMenu}>Blog</Link></li>
          <li><Link to="/sponsorship"   onClick={closeMenu}>Sponsorship</Link></li>
          <li><Link to="/opportunities" onClick={closeMenu}>Opportunities</Link></li>

          {isLoggedIn && (
            <li>
              <Link to="/dashboard" onClick={closeMenu} className="nav-member-link">
                👤 Member
              </Link>
            </li>
          )}

          {isLoggedIn && isLeader && (
            <li>
              <Link to="/leader-portal" onClick={closeMenu} className="nav-leader-link">
                🛡 Leader Portal
              </Link>
            </li>
          )}
        </ul>
      </nav>

      <div className="navbar-auth">
        {isLoggedIn ? (
          <button className="logout-btn" onClick={handleLogout}>
            Logout
          </button>
        ) : (
          <Link to="/login" className="login-btn" onClick={closeMenu}>
            Login
          </Link>
        )}
      </div>
    </header>
  );
};

export default Navbar;